import { Divider, Stack } from '@mui/material';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import PacmanLoader from 'react-spinners/PacmanLoader';
import { SyncSummary } from './MachineGroupMachines';

type Params = {
  syncSummary: SyncSummary | undefined;
};

function GroupSyncSummary({ syncSummary }: Params) {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(0.9),
    textAlign: 'center',
    color: 'black',
  }));

  return (
    <div style={{ paddingBottom: '2em' }}>
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={1.3}
      >
        <Item elevation={4}>
          Pending: {syncSummary?.groupTaskSummary.pending ?? 0}
        </Item>
        <Item elevation={4}>
          In Progress: {syncSummary?.groupTaskSummary.inProgress ?? 0}
        </Item>
        <Item elevation={4}>
          Success: {syncSummary?.groupTaskSummary.finished ?? 0}
        </Item>
        <Item elevation={4}>
          Failed: {syncSummary?.groupTaskSummary.failed ?? 0}
        </Item>
        <Item elevation={4}>
          Cancelled: {syncSummary?.groupTaskSummary.cancelled ?? 0}
        </Item>
        {syncSummary?.groupTaskSummary?.aggregatedStatus === 'Finished' ||
        syncSummary?.groupTaskSummary?.aggregatedStatus === 'Cancelled' ||
        syncSummary?.groupTaskSummary.aggregatedStatus === 'None' ||
        syncSummary?.groupTaskSummary.aggregatedStatus === 'Failed' ||
        syncSummary?.groupTaskSummary?.aggregatedStatus === undefined ? (
          ''
        ) : (
          <Item
            elevation={4}
            sx={{
              display: 'flex',
              alignItems: 'center',
              background: '#142A4D',
              paddingRight: '3em',
            }}
          >
            <span
              style={{
                paddingRight: '1em',
                alignContent: 'center',
                color: 'white',
              }}
            >{`Sync: ${syncSummary?.groupTaskSummary?.aggregatedStatus} | Process ID: ${syncSummary?.lastSyncProcess?.id} |`}</span>
            <PacmanLoader size="1rem" color="white" />
          </Item>
        )}
      </Stack>
    </div>
  );
}

export default GroupSyncSummary;
